import { render, staticRenderFns } from "./NewPackage.vue?vue&type=template&id=6b7ee212&scoped=true&"
import script from "./NewPackage.vue?vue&type=script&lang=js&"
export * from "./NewPackage.vue?vue&type=script&lang=js&"
import style0 from "./NewPackage.vue?vue&type=style&index=0&id=6b7ee212&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7ee212",
  null
  
)

export default component.exports